import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ExclamationOctagonFill } from 'react-bootstrap-icons';
import { colors } from '../theme/colors';
import { usePositionClose } from '../contexts/PositionCloseContext';

const AutoCloseConfirmModal = () => {
  const { confirmRequest, closeConfirmation } = usePositionClose();

  const handleCancel = () => {
    if (confirmRequest?.onCancel) confirmRequest.onCancel();
    closeConfirmation();
  };

  const handleConfirm = async () => {
    try {
      if (confirmRequest?.onConfirm) await confirmRequest.onConfirm();
    } finally {
      closeConfirmation();
    }
  };

  return (
    <Modal show={!!confirmRequest} onHide={handleCancel} centered contentClassName="auto-close-modal-content">
      <Modal.Header closeButton style={{ backgroundColor: colors.bgPrimary, color: colors.text, borderBottom: 'none' }}>
        <Modal.Title style={{ color: colors.text, display: 'flex', alignItems: 'center', gap: 8 }}>
          <ExclamationOctagonFill size={18} style={{ color: colors.danger }} />
          Loss Limit Exceeded
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: colors.bgPrimary, color: colors.text }}>
        <div style={{ lineHeight: 1.5 }}>
          {confirmRequest?.message || 'Your configured loss limit has been exceeded. Do you want to close the position now?'}
        </div>
        {typeof confirmRequest?.loss === 'number' && (
          <div className="mt-3" style={{ fontWeight: 600 }}>
            Current Unrealized Loss: <span style={{ color: colors.chartDown }}>
              {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(confirmRequest.loss)}
            </span>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: colors.bgPrimary, borderTop: 'none' }}>
        <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
        <Button variant="danger" onClick={handleConfirm}>Confirm Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AutoCloseConfirmModal;


